module.exports = __webpack_public_path__ + "img/Vangsgutane_Bilde-av-Vangsgutane-til-høyre-for-Ingeniør-Knut-Berg-på-eventyr.677e6658.jpg";